/* ---------------------------------------------------------------
   Kuno · Suchschicht · 27.08.2026
   Siebte Schicht neben logik / produkte / wiring / schicht2 /
   passt_zu / render. Sie liegt zwischen kuno-logik.js und
   kuno-render.js und besitzt genau ein Thema: was aus einer
   Anfrage mit mehr als einem Wort wird.

   Behebt vier gemeldete Fehler:
     1  "Supplements" zeigte 10 von 23 Artikeln, "melatonin" wurde
        ueberhaupt nicht gelesen
     2  ab zwei Woertern zaehlte nur das erste Wort
     3  alles mit snack/salz/nuss/pistaz/mandel bekam die
        Ueberschrift "Ungesalzene Bio-Pistazien"
     4  "vegan" und "vegetarisch" lieferten nichts

   Geprueft in der Vorschau: alle geschuetzten Antworten liefern
   unveraendert dasselbe - Sperrliste, Umlenkungen samt 10209,
   Rezept, Erzeuger, Sorte, Bio, Sensorik, Vergleich, Berechnung,
   Versand, Preis-Superlativ, Spitzenqualitaet, Bestseller.
   --------------------------------------------------------------- */
(function () {
  'use strict';
  if (typeof PRODUKTE === 'undefined' || typeof WARENGRUPPEN === 'undefined') return;
  if (window.KUNO_SUCHE) return;
  window.KUNO_SUCHE = '2026-08-27';

  var B = 'https://cdn.shopify.com/s/files/1/0961/6336/5203/files/';

  /* ============================================================
     1 · Daten: die dreizehn fehlenden Nahrungsergaenzungen
     Preis, Lieferbarkeit und Link holt liveAbgleich() beim
     Seitenaufruf ueber die SKU aus dem Shop.
     Der Zutaten-Eintrag steht woertlich im echten Produkttext.
     ============================================================ */
  var ERG_NEU = [
{s:"10315",k:"erg",t:"Basis-Duo | Vitamin D3K2 + Magnesium-Komplex",p:39.9,i:B+"render_5569aaf6-f3e3-4258-95ea-7627d579f960.jpg",n:"",lieferbar:true,url:"/products/basis-duo-vitamin-d3k2-magnesium-komplex",zutat:"magnesium vitamin d3"},
{s:"10079",k:"erg",t:"Rockets »Bio Beauty Fruchtgummis« – für Haut, Haare & Nägel",p:19.9,i:B+"Beauty-Bio-Fruchtgummi-Supplement_1920x1920_59feb9c0-f69e-47fc-9f1f-48383b2d0573.webp",n:"",lieferbar:true,url:"/products/bio-beauty-fruchtgummi-biotin-zink-vitamin-a-vitamin-c-folsaeure-vegan-glutenfrei-240g",zutat:"zink biotin folsäure vitamin a vitamin c",vegan:2},
{s:"10102",k:"erg",t:"Blutdruck-Tabletten 126 Tabl.",p:22.5,i:B+"NBL-1_800x800_facab403-6880-47d1-be1a-125091bf05c5.jpg",n:"",lieferbar:true,url:"/products/blutdruck-tabletten-126-tabl",zutat:"magnesium kalium zink vitamin b vitamin c kollagen"},
{s:"10177",k:"erg",t:"Vital-Duo | MoleQlar OmegaSOL + Dr. Jacob's D3K2 Öl",p:64.7,i:B+"freepik_erstelle-schlichtes-bild-_2782814298.png",n:"",lieferbar:true,url:"/products/bundle-empfehlung-moleqlar-omegasol-dr-jacobs-d3k2-ol",zutat:"omega-3 dha epa vitamin d3 vitamin k2",vegan:1},
{s:"10316",k:"erg",t:"Basis-Trio | Vitamin D3K2 + Magnesium + OmegaSOL",p:79.9,i:B+"render_d1d77966-fc04-4b4d-bbb8-d715f4d4c735.jpg",n:"",lieferbar:true,url:"/products/basis-trio-vitamin-d3k2-magnesium-omegasol",zutat:"magnesium omega-3 vitamin d3",vegan:2},
{s:"10080",k:"erg",t:"Rockets »Bio Focus Fruchtgummis«",p:19.9,i:B+"Fokus-Bio-Fruchtgummi-Supplements_1920x1920_465f8491-74d9-4317-89ef-af1fd48b6092.webp",n:"",lieferbar:true,url:"/products/bio-focus-fruchtgummi-gruener-tee-guaran-extrakt-vegan-glutenfrei-240g",zutat:"guarana koffein grüner tee",koffein:true,vegan:2},
{s:"10101",k:"erg",t:"Dr. Jacob's Blutdruck®-Salz 250 g",p:5.49,i:B+"NBS2-1_800x800_1e24b3cf-0ee5-4e6d-854c-a34781157219.webp",n:"",lieferbar:true,url:"/products/dr-jacobs-blutdruck®-salz-250-g",zutat:"kalium"},
{s:"10317",k:"erg",t:"Das große Basis-Set | Fünf abgestimmte Produkte",p:149.9,i:B+"render_ef693ead-99d9-4102-9fd0-a0d52315c3c4.jpg",n:"",lieferbar:true,url:"/products/das-grosse-basis-set-funf-abgestimmte-produkte",zutat:"magnesium omega-3 vitamin d3 coenzym q10 spermidin",vegan:2},
{s:"10082",k:"erg",t:"Rockets »Bio Immun Fruchtgummis«",p:19.9,i:B+"Immun-Bio-Fruchtgummi-Supplement_1920x1920_bd4e7366-a288-4ad1-b503-f1fc7a0009c5.webp",n:"",lieferbar:true,url:"/products/bio-immun-fruchtgummi-vitamin-c-aus-hagebutte-zink-240g-60-stueck",zutat:"zink vitamin c hagebutte"},
{s:"10106",k:"erg",t:"Dr. Jacob's Blutdruck®-Salz 500 g Beutel",p:9.95,i:B+"NBSB-1_800x800_cca060ad-78e8-42eb-afc0-ca7a56012020.webp",n:"",lieferbar:true,url:"/products/dr-jacobs-blutdruck®-salz-500-g-beutel",zutat:"kalium"},
{s:"10081",k:"erg",t:"Rockets »Bio Sleep Fruchtgummis«",p:19.9,i:B+"Sleep-Bio-Fruchtgummi-Supplement_1920x1920_d5e8da05-0067-43e2-a9db-29a0c9ae3557.webp",n:"",lieferbar:true,url:"/products/bio-sleep-fruchtgummi-melatonin-baldriansaft-sauerkirschenpulver-vegan-glutenfrei-240g",zutat:"melatonin",vegan:2},
{s:"10078",k:"erg",t:"Rockets »Bio Superfoods Fruchtgummis«",p:19.9,i:B+"Superfoods-Bio-Fruchtgummi-Supplement_1920x1920_eb4f09e7-b5bc-4023-8473-c3e72e264267.webp",n:"",lieferbar:true,url:"/products/bio-beauty-fruchtgummi-camu-camu-karotte-als-naturliche-vitaminquellen-mit-biotin-zink-folsaure-vegan-glutenfrei-240g-kopie",zutat:"zink folsäure vitamin c hagebutte",vegan:2},
{s:"10104",k:"erg",t:"Dr. Jacob's Vitamin D3K2 Öl forte 20 ml",p:30.7,i:B+"ND3K2F-1_800x800_10ad68d4-9e0a-4243-9184-a89087cf659c.webp",n:"",lieferbar:true,url:"/products/dr-jacobs-vitamin-d3k2-ol-forte-20-ml",zutat:"magnesium kalium calcium vitamin d3 vitamin e"}
  ];

  var ERG_ZUTAT = {
    "10143":"magnesium vitamin b",
    "10043":"zink eisen selen vitamin b vitamin c kollagen",
    "10103":"magnesium kalium calcium vitamin d3 vitamin e",
    "10140":"coenzym q10",
    "10152":"eisen biotin folsäure vitamin b",
    "10142":"kreatin",
    "10105":"vitamin b coenzym q10 taurin",
    "10147":"spermidin",
    "10149":"vitamin d",
    "10150":"calcium vitamin d3 vitamin k2"
  };

  /* Vegan ist eine Auszeichnung, keine Vermutung - dieselbe Beweisregel
     wie bei Bio. 1 = Wort im echten Produkttitel, 2 = in der echten
     Produktbeschreibung. Ein Shop-Tag dafuer gibt es nicht. */
  var VEGAN_TITEL = ["10257","10254","10251","10248","10245","10170","10171",
                     "10179","10180","10181","10129","10076","10075","10074"];
  var VEGAN_TEXT  = ["WV-1101","10134","10152","10143","10142","10140","10090",
                     "10127","10059"];

  var bekannt = {};
  PRODUKTE.forEach(function (p) { bekannt[p.s] = true; });
  ERG_NEU.forEach(function (p) { if (!bekannt[p.s]) PRODUKTE.push(p); });
  PRODUKTE.forEach(function (p) {
    if (ERG_ZUTAT[p.s]) p.zutat = ERG_ZUTAT[p.s];
    if (VEGAN_TITEL.indexOf(p.s) >= 0) p.vegan = 1;
    else if (VEGAN_TEXT.indexOf(p.s) >= 0) p.vegan = 2;
  });

  /* ============================================================
     2 · Wortwerkzeug
     Drei Stufen, die auseinandergehalten werden muessen:
       flach      Umlaute ausgeschrieben     "nuesse"
       kern       ae/oe/ue zusammengezogen   "nusse"   (zum Suchen)
       schluessel plus Schwa-e getilgt       "nuss"    (zum Nachschlagen)
     Frage und Tabelleneintrag muessen dieselbe Stufe benutzen,
     sonst greift ein Eintrag nie. Genau daran ist beim Bauen
     zweimal etwas vorbeigelaufen: dunkel/dunkle und
     gesalzen/gesalzene.
     ============================================================ */
  var FUELLWORT = {};
  ('zeig zeige zeigt mir mal bitte danke kuno ich du ihr wir welche welcher welches ' +
   'welchen was wer wie wo gibt gibts habt hast haben hat ist sind war suche such ' +
   'suchen brauche brauch braucht moechte moechten will wollte haette gern gerne ' +
   'finde finden der die das den dem des ein eine einen einem einer eines und oder ' +
   'aber auch noch alle allen alles etwas mit ohne in fuer von vom aus bei zum zur ' +
   'als auf im am an es dazu euer eure eures euren unser unsere artikel produkt ' +
   'produkte sortiment angebot liste auswahl stueck hallo eignet eignen passt'
  ).split(' ').forEach(function (w) { FUELLWORT[w] = true; });

  function flach(s) {
    return String(s == null ? '' : s).toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
  }
  function kern(s) {
    return flach(s).replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
  }
  var ENDUNG = ['ungen', 'enen', 'ern', 'end', 'en', 'er', 'es', 'em', 'e', 'n', 's'];
  function grund(w) {
    var x = flach(w), i, e;
    for (i = 0; i < ENDUNG.length; i++) {
      e = ENDUNG[i];
      if (x.length - e.length >= 4 && x.slice(-e.length) === e) return x.slice(0, x.length - e.length);
    }
    return x;
  }
  function stamm(w) { return kern(grund(w)); }
  function schluessel(w) { return stamm(w).replace(/e([lrn])$/, '$1'); }
  function heuhaufen(p) { return kern([p.t, p.n || '', p.zutat || ''].join(' ')); }

  /* Woerter, die im Sortiment anders heissen als in der Frage.
     Waechst mit dem Fragenprotokoll - das ist die Wartungsstelle. */
  var SYN_ROH = {
    nuss:     ['mandel','pistazie','walnuss','cashew','macadamia','pekan','erdnuss','haselnuss','nussmisch'],
    dunkel:   ['zartbitter','70 %','80 %','92 %','edelbitter'],
    hell:     ['vollmilch','weisse'],
    scharf:   ['chili','pikant','ingwer'],
    herzhaft: ['wurzig','pikant','salzig'],
    fruchtig: ['frucht','beere','mango','ananas','kirsch','orange','zitrone'],
    knusprig: ['gerostet','rost'],
    suess:    ['honig','karamell','dattel','schoko'],
    cremig:   ['mus','creme','aufstrich'],
    klein:    ['probier','einsteiger','kennenlern']
  };
  var SYNONYM = {};
  Object.keys(SYN_ROH).forEach(function (k) {
    SYNONYM[schluessel(k)] = SYN_ROH[k].map(kern);
  });

  /* Woerter, zu denen es ein echtes Merkmal gibt. Das Merkmal schlaegt
     den Text: nur ein Artikel nennt "Koffein" im Titel, 18 tragen das
     Merkmal. */
  var FELD_ROH = {
    koffein:       function (p) { return !!p.koffein; },
    koffeinhaltig: function (p) { return !!p.koffein; },
    koffeinfrei:   function (p) { return !p.koffein; },
    bio:           function (p) { return !!p.bio; },
    vegan:         function (p) { return !!p.vegan; },
    kalt:          function (p) { return !!p.kalt; },
    kaltaufguss:   function (p) { return !!p.kalt; }
  };
  var FELD = {};
  Object.keys(FELD_ROH).forEach(function (k) { FELD[schluessel(k)] = FELD_ROH[k]; });

  /* Teilwort-Fallen. Projektregel 3: jedes neue Schluesselwort hier
     gegenpruefen. */
  var WORT_FALLE = [
    { re: /^(salz|gesalz)/, nie: /ungesalzen/ },
    { re: /^zucker/,        nie: /zuckerarm|zuckerfrei/ },
    { re: /^nuss/,          nie: /genuss/ }
  ];

  /* Woerter, die eigentlich eine Zahl meinen. Wird eines als Filter
     benutzt, sagt die Antwort dazu, dass der Produkttext gefiltert
     wurde und nicht der Naehrwert. */
  var NAEHRWORT = /^(salz|gesalz|zucker|fett|kalori|kcal|eiweiss|protein|ballaststoff)/;

  function trefferWort(p, wort) {
    var s1 = stamm(wort), k1 = schluessel(wort), i, f, heu, syn;
    if (FELD[k1]) return FELD[k1](p);
    heu = heuhaufen(p);
    for (i = 0; i < WORT_FALLE.length; i++) {
      f = WORT_FALLE[i];
      if (f.re.test(k1) || f.re.test(s1)) { heu = heu.replace(new RegExp(f.nie, 'g'), ' '); break; }
    }
    if (heu.indexOf(s1) >= 0) return true;
    syn = SYNONYM[k1] || SYNONYM[s1];
    if (!syn) return false;
    for (i = 0; i < syn.length; i++) if (heu.indexOf(syn[i]) >= 0) return true;
    return false;
  }

  function einmal(liste) {
    var gesehen = {}, raus = [];
    liste.forEach(function (x) { if (x && !gesehen[x]) { gesehen[x] = true; raus.push(x); } });
    return raus;
  }

  /* Vom Gruppennamen wird nur die eine Stelle entfernt, die wirklich
     getroffen hat. Wuerde die ganze Gruppen-Regex geloescht,
     verschwaende bei "Supplements magnesium" auch das Wort magnesium,
     weil es in derselben Regex steht. Genau das war Fehler 1. */
  function restWoerter(s, w) {
    var rest = ' ' + String(s == null ? '' : s).toLowerCase() + ' ';
    var gruppenwort = null, m, negativ = [], positiv;
    if (w && w.re) {
      m = new RegExp(w.re.source).exec(rest);
      if (m) { gruppenwort = String(m[2] || m[0]).trim(); rest = rest.replace(m[0], ' '); }
    }
    rest = rest.replace(/(^|\s)(ohne|kein|keine|keinen|keinem|nicht)\s+([a-zäöüß\-]{3,})/g,
      function (all, a, b, wort) { negativ.push(wort); return ' '; });
    positiv = rest.split(/[^a-zäöüß0-9\-]+/).filter(function (x) {
      return x.length >= 3 && !FUELLWORT[flach(x)];
    });
    return { positiv: einmal(positiv), negativ: einmal(negativ), gruppenwort: gruppenwort };
  }

  /* Kernstueck fuer Fehler 2. Vier Ausgaenge:
       benutzt      das Wort hat gefiltert
       neutral      das Wort trifft alles, grenzt also nichts ein
       leerGelaufen das Wort ist im Sortiment bekannt, in DIESER Gruppe
                    gibt es aber nichts dazu -> ehrliches Nein
       unbekannt    Kuno kennt das Wort nicht -> Gruppe bleibt ganz und
                    das Wort wird offen genannt */
  function verfeinern(s, w, alle) {
    var R = restWoerter(s, w), liste = alle.slice();
    var benutzt = [], unbekannt = [], leerGelaufen = [], naehr = false;
    R.positiv.forEach(function (wort) {
      var g = liste.filter(function (p) { return trefferWort(p, wort); });
      if (g.length === liste.length && g.length > 0) return;
      if (g.length) {
        liste = g; benutzt.push(wort);
        if (NAEHRWORT.test(schluessel(wort))) naehr = true;
      } else if (alle.some(function (p) { return trefferWort(p, wort); }) ||
                 PRODUKTE.some(function (p) { return trefferWort(p, wort); })) {
        leerGelaufen.push(wort); liste = [];
      } else unbekannt.push(wort);
    });
    R.negativ.forEach(function (wort) {
      var g = liste.filter(function (p) { return !trefferWort(p, wort); });
      if (g.length !== liste.length) {
        liste = g; benutzt.push('ohne ' + wort);
        if (NAEHRWORT.test(schluessel(wort))) naehr = true;
      } else unbekannt.push('ohne ' + wort);
    });
    /* Nennt die Frage nur ein einzelnes Produktwort ("Pistazien",
       "Balsamico"), grenzt dieses Wort selbst ein - aber nur, wenn es
       nicht der Name der Gruppe ist und wirklich etwas findet. */
    if (!benutzt.length && !leerGelaufen.length && R.gruppenwort && w) {
      var label = kern(w.label), gw = kern(R.gruppenwort);
      if (label.indexOf(gw) !== 0 && gw.indexOf(label.split(' ')[0]) !== 0) {
        var g2 = alle.filter(function (p) { return trefferWort(p, R.gruppenwort); });
        if (g2.length && g2.length < alle.length) { liste = g2; benutzt.push(R.gruppenwort); }
      }
    }
    return {
      liste: liste, benutzt: benutzt, unbekannt: unbekannt,
      leerGelaufen: leerGelaufen, naehr: naehr,
      eingegrenzt: benutzt.length > 0 || leerGelaufen.length > 0
    };
  }

  /* Antwort auf "was haette ich denn fragen koennen". */
  function filterWoerter(alle) {
    var z = {};
    alle.forEach(function (p) {
      (String(p.n || '') + ' ' + String(p.zutat || '')).toLowerCase()
        .split(/[^a-zäöüß0-9\-]+/)
        .filter(function (x) { return x.length >= 4; })
        .forEach(function (x) { z[x] = (z[x] || 0) + 1; });
    });
    return Object.keys(z).filter(function (x) { return z[x] < alle.length; })
      .sort(function (a, b) { return z[b] - z[a]; }).slice(0, 10);
  }

  function artikelVon(w) {
    return PRODUKTE.filter(function (p) {
      return w.ks ? w.ks.indexOf(p.k) >= 0 : p.k === w.k;
    });
  }
  function gruppeZu(s) {
    var i;
    for (i = 0; i < WARENGRUPPEN.length; i++) if (WARENGRUPPEN[i].re.test(s)) return WARENGRUPPEN[i];
    return null;
  }
  function istEingegrenzt(s) {
    var w = gruppeZu(s);
    if (!w) return false;
    return verfeinern(s, w, artikelVon(w)).eingegrenzt;
  }

  /* ============================================================
     3 · Drei fehlende Warengruppen
     Nuesse, Tee und Snacks hatten keinen Eintrag und liefen deshalb
     ueber die Einzelwort-Kette in classify() in results.snack.
     nussmus steht vor nuss, sonst faengt "nuss" das Nussmus ab.
     Die Wortgrenze ist als Zeichenklasse gebaut, nicht als \b -
     Projektregel 4. "Genuss" faellt heraus, weil vor "nuss" ein "e"
     steht - Projektregel 3.
     ============================================================ */
  var GRUPPE_NUSS = {
    re: /(^|[^a-zäöüß])(nuss|nüsse|nüssen|nusskerne|nussmischung|pistazie|pistazien|mandel|mandeln|walnuss|walnüsse|cashew|cashews|macadamia|pekannuss|pekannüsse|erdnuss|erdnüsse)($|[^a-zäöüß])/,
    k: 'nuss', label: 'Nüsse',
    hinweis: 'Alle Angaben je 100 g vom Etikett.'
  };
  var GRUPPE_TEE = {
    re: /(^|[^a-zäöüß])(tee|tees|teesorte|teesorten|grüntee|gruentee|schwarztee|kräutertee|kraeutertee|früchtetee|fruechtetee|bancha|sencha|hojicha|rooibos)($|[^a-zäöüß])/,
    k: 'tee', label: 'Tee',
    hinweis: 'Koffein steht je Tasse auf der Karte.'
  };
  var GRUPPE_SNACK = {
    re: /(^|[^a-zäöüß])(snack|snacks|knabber|knabberei|knabbereien|naschen|nascherei)($|[^a-zäöüß])/,
    ks: ['nuss', 'trockenfrucht', 'riegel', 'schoko', 'suesses'],
    k: 'snack', label: 'Snacks',
    hinweis: 'Nüsse, Trockenfrüchte, Gemüseriegel, Schokolade und Fruchtgummi.'
  };

  (function () {
    var vorhanden = {};
    WARENGRUPPEN.forEach(function (w) { vorhanden[w.k] = true; });
    var nachNussmus = -1, i;
    for (i = 0; i < WARENGRUPPEN.length; i++) if (WARENGRUPPEN[i].k === 'nussmus') nachNussmus = i;
    if (!vorhanden.nuss && !vorhanden.tee) {
      if (nachNussmus >= 0) WARENGRUPPEN.splice(nachNussmus + 1, 0, GRUPPE_NUSS, GRUPPE_TEE);
      else { WARENGRUPPEN.push(GRUPPE_NUSS); WARENGRUPPEN.push(GRUPPE_TEE); }
    }
    if (!vorhanden.snack) WARENGRUPPEN.push(GRUPPE_SNACK);
  })();

  /* ============================================================
     4 · Warengruppen-Antwort, die wirklich filtert
     ============================================================ */
  function neueWarengruppenAntwort(s) {
    var w = gruppeZu(s);
    if (!w) return null;
    var alle = artikelVon(w);
    if (!alle.length) return null;

    var v = verfeinern(s, w, alle);
    var geschenk = w.k === 'set' &&
      /(geschenk|verschenk|box|boxen|kiste|präsent|praesent|mitbringsel)/.test(s);

    if (!v.liste.length) {
      var woerter = v.leerGelaufen.concat(v.benutzt);
      var moeglich = filterWoerter(alle);
      return {
        summary: 'Die Warengruppe ist klar, die Einschränkung passt dazu aber nicht.',
        tags: [w.label, 'kein Treffer'],
        vorfilter: [],
        eyebrow: 'Kein Treffer',
        title: w.label + ': nichts mit „' + woerter.join(', ') + '“',
        intro: 'In ' + w.label + ' liegt kein Artikel, auf den „' + woerter.join(', ') +
               '“ zutrifft. Kuno zeigt lieber nichts als etwas Falsches.' +
               (moeglich.length ? ' In dieser Gruppe lässt sich filtern nach: ' + moeglich.join(', ') + '.' : ''),
        visual: 'help', refine: true,
        pick: function () { return []; },
        metrics: [],
        why: 'Gefiltert wurde im Sortiment, nicht geraten.',
        limit: 'das gesuchte Wort im Sortiment anders heißt — dann gehört es ins Wörterbuch.',
        evidence: '0 von ' + alle.length + ' Artikeln in ' + w.label,
        source: 'Produkttitel und belegte Zutatenangabe.'
      };
    }

    var sortiert = (typeof nachVerkauf === 'function') ? nachVerkauf(v.liste) : v.liste;
    var liste = geschenk
      ? sortiert.filter(function (p) { return p.kiste; })
                .concat(sortiert.filter(function (p) { return !p.kiste; }))
      : sortiert;
    var ordnung = geschenk
      ? ' Die Holzkiste steht vorn, danach zählt die Verkaufshäufigkeit.'
      : ' Sortiert nach Verkaufshäufigkeit, meistgekaufter Artikel zuerst.';
    var eng = v.benutzt.length > 0;
    var offen = v.unbekannt.length
      ? ' Nicht filtern konnte Kuno: „' + v.unbekannt.join(', ') + '“ — das Wort steht auf der Wartungsliste.'
      : '';
    var zahlHinweis = v.naehr
      ? ' Gefiltert wurde der Produkttext, nicht der Nährwert — für die Zahl frag nach dem Wert je Portion.'
      : '';

    return {
      summary: eng
        ? 'Warengruppe und Einschränkung sind angekommen. Beides zusammen ergibt diese Liste.'
        : 'Du hast eine Warengruppe genannt. auteniQ zeigt, was davon im Sortiment liegt.',
      tags: [w.label, liste.length + ' Artikel'].concat(v.benutzt),
      vorfilter: [],
      eyebrow: 'Warengruppe',
      title: eng
        ? w.label + ' · ' + v.benutzt.join(', ') + ': ' + liste.length + ' Artikel'
        : w.label + ', ' + liste.length + ' Artikel',
      intro: (w.hinweis || '') + ordnung +
             (eng ? ' Aus ' + alle.length + ' Artikeln der Gruppe bleiben ' + liste.length + '.' : '') +
             offen + zahlHinweis,
      visual: 'help', refine: false,
      pick: function () { return liste; },
      metrics: [],
      why: 'Die Liste kommt aus dem Sortiment, die Reihenfolge aus den echten Bestellzahlen — nicht aus einer Auswahl von Hand.',
      limit: 'du zusätzlich nach Geschmack sortieren willst. Die Verkostungswerte fehlen noch.',
      evidence: eng
        ? v.benutzt.length + ' Einschränkung(en) auf ' + alle.length + ' Artikel angewendet'
        : alle.length + ' Artikel in ' + w.label,
      source: 'Produkttitel und belegte Zutatenangabe.'
    };
  }

  /* ============================================================
     5 · vegan und vegetarisch
     ============================================================ */
  var RE_VEGAN = /(^|[^a-zäöüß])(vegan|vegane|veganer|veganes|veganen|rein pflanzlich|pflanzlich|pflanzliche|pflanzlichen)($|[^a-zäöüß])/;
  var RE_VEGETARISCH = /(^|[^a-zäöüß])(vegetarisch|vegetarische|vegetarisches|vegetarischen|ohne fleisch|fleischlos)($|[^a-zäöüß])/;

  function veganAntwort(s) {
    if (!RE_VEGAN.test(s)) return null;
    var w = gruppeZu(s);
    var basis = PRODUKTE.filter(function (p) { return p.vegan; });
    var liste = w ? basis.filter(function (p) {
      return w.ks ? w.ks.indexOf(p.k) >= 0 : p.k === w.k;
    }) : basis;
    var s1 = liste.filter(function (p) { return p.vegan === 1; }).length;

    if (!liste.length) return {
      summary: 'Ausgezeichnet ist in dieser Gruppe nichts.',
      tags: ['vegan', 'kein Treffer'], vorfilter: [],
      eyebrow: 'Kein Treffer',
      title: (w ? w.label + ': ' : '') + 'nichts ausdrücklich als vegan ausgezeichnet',
      intro: 'Im Sortiment sind ' + basis.length + ' Artikel als vegan ausgezeichnet' +
             (w ? ', in ' + w.label + ' keiner' : '') +
             '. Das heißt nicht, dass es dort nichts Pflanzliches gibt — es ist nur nicht ausgezeichnet.',
      visual: 'help', refine: true,
      pick: function () { return []; }, metrics: [],
      why: 'Nur was der Shop selbst als vegan ausschreibt, zählt.',
      limit: 'ein Artikel pflanzlich ist, ohne dass es im Text steht.',
      evidence: '0 belegte Auszeichnungen in dieser Gruppe',
      source: 'Produkttitel und Produktbeschreibung.'
    };

    return {
      summary: 'Vegan ist eine Auszeichnung, keine Vermutung. Hier steht nur, was auteniQ selbst so ausschreibt.',
      tags: ['vegan', liste.length + ' Artikel'].concat(w ? [w.label] : []),
      vorfilter: [],
      eyebrow: 'Vegan',
      title: 'Vegan' + (w ? ' in ' + w.label : '') + ': ' + liste.length + ' Artikel',
      intro: s1 + ' davon tragen das Wort im Produkttitel, ' + (liste.length - s1) +
             ' in der Produktbeschreibung. Sortiert nach Verkaufshäufigkeit.',
      visual: 'help', refine: false,
      pick: function () { return (typeof nachVerkauf === 'function') ? nachVerkauf(liste) : liste; },
      metrics: [],
      why: 'Beleg ist der echte Produkttext, nicht eine Einschätzung der Zutaten.',
      limit: 'das Sortiment größer ist als die Liste — ausgezeichnet ist bisher nur ein Teil.',
      evidence: s1 + ' im Titel belegt, ' + (liste.length - s1) + ' in der Beschreibung',
      source: 'Produkttitel und Produktbeschreibung, Stand 27.08.2026.'
    };
  }

  function vegetarischAntwort(s) {
    if (!RE_VEGETARISCH.test(s)) return null;
    var w = gruppeZu(s);
    var fleisch = PRODUKTE.filter(function (p) { return p.k === 'schinken'; });
    var liste = PRODUKTE.filter(function (p) { return p.k !== 'schinken'; });
    if (w && w.k !== 'schinken') liste = liste.filter(function (p) {
      return w.ks ? w.ks.indexOf(p.k) >= 0 : p.k === w.k;
    });
    var vegan = liste.filter(function (p) { return p.vegan; }).length;

    return {
      summary: 'Fleisch führt auteniQ in genau einer Warengruppe. Der Rest ist fleischlos.',
      tags: ['vegetarisch', liste.length + ' Artikel'].concat(w ? [w.label] : []),
      vorfilter: [],
      eyebrow: 'Vegetarisch',
      title: 'Ohne Fleisch' + (w ? ' in ' + w.label : '') + ': ' + liste.length + ' Artikel',
      intro: 'Fleisch führt auteniQ nur im Ibérico — ' + fleisch.length +
             ' Artikel, die hier fehlen. Ausdrücklich als vegan ausgezeichnet sind davon ' +
             vegan + '; die zeigt Kuno auf „vegan“. Sortiert nach Verkaufshäufigkeit.',
      visual: 'help', refine: false,
      pick: function () { return (typeof nachVerkauf === 'function') ? nachVerkauf(liste) : liste; },
      metrics: [],
      why: 'Gezählt wird die Warengruppe, nicht geraten.',
      limit: 'es um Ei, Milch oder Honig geht — die sind im Sortiment nicht einzeln erfasst.',
      evidence: fleisch.length + ' Fleischartikel von ' + PRODUKTE.length + ' im Sortiment',
      source: 'Warengruppe aus dem Artikel-Schnappschuss.'
    };
  }

  /* ============================================================
     6 · Ueberschriften, die einen Produktnamen tragen
     ============================================================ */
  if (typeof results !== 'undefined') {
    if (results.snack) {
      results.snack.eyebrow = 'Anliegen';
      results.snack.title = 'Herzhafte Snacks für abends';
    }
    if (results.protein) results.protein.title = 'Eiweiß je Portion: die belegten Artikel';
    if (results.fiber)   results.fiber.title   = 'Ballaststoffe je 100 g: die belegten Artikel';
    if (results.ingredients) results.ingredients.title = 'Artikel mit einer einzigen Zutat';
  }

  /* Fuenfte Stelle, in der Vorschau gefunden: die Darm-Umlenkung trug
     "Würziger Kürbis Riegel" als Ueberschrift. Vier der fuenf
     Umlenkungen heissen "Geschmacksfrage", diese eine nannte ein
     Produkt - unter einer Beschwerdefrage liest sich das wie eine
     Empfehlung, Abschnitt 6.1. Der Ballaststoff-Weg bleibt, er ist
     Weg 4: nur die Zahl. Geaendert wird allein die Ueberschrift. */
  var TITEL_IST_PRODUKT = {};
  PRODUKTE.forEach(function (p) {
    TITEL_IST_PRODUKT[p.t] = true;
    /* Die Ueberschrift trug den GEKUERZTEN Produktnamen, nicht den
       vollen Titel - ein Vergleich nur gegen p.t findet sie nie. */
    if (typeof kurz === 'function') TITEL_IST_PRODUKT[kurz(p.t)] = true;
  });
  if (typeof UMLENK !== 'undefined') UMLENK.forEach(function (u) {
    var r = u.result;
    if (!r || !r.title || !TITEL_IST_PRODUKT[r.title]) return;
    r.title = /ballaststoff/i.test(String(r.intro || '') + String(r.redirect || ''))
      ? 'Ballaststoffe je 100 g — der höchste belegte Wert'
      : 'Die Zahlen dazu';
  });

  /* Eigene Antwort fuer "ohne Salz", damit die Liste nicht verloren
     geht, wenn der Snack-Sammelzweig nicht mehr greift. */
  function salzAntwort() {
    if (typeof results === 'undefined' || !results.snack) return null;
    var kopie = {}, k;
    for (k in results.snack) if (Object.prototype.hasOwnProperty.call(results.snack, k)) kopie[k] = results.snack[k];
    var n = kopie.pick ? kopie.pick().length : 0;
    kopie.eyebrow = 'Salzbewusst';
    kopie.title = 'Ohne zugesetztes Salz: ' + n + ' Artikel';
    return kopie;
  }

  /* ============================================================
     7 · Die Regel, um die es Alexander ging
     Nennt eine Anfrage eine Warengruppe UND grenzt sie ein, gewinnt
     die zugeschnittene Gruppenantwort gegen die Einzelwort-Kette.
     Nennt sie nur die Gruppe, bleibt alles wie bisher.

     Die Spezialantworten laufen davor und behalten Vorrang - sonst
     landet "Rezepte mit Honig" in der Honig-Gruppe statt im Magazin.
     Projektregel 2.
     ============================================================ */
  if (typeof warengruppenAntwort === 'function') {
    warengruppenAntwort = neueWarengruppenAntwort;
  }
  window.veganAntwort = veganAntwort;
  window.vegetarischAntwort = vegetarischAntwort;
  window.kunoVerfeinern = verfeinern;
  window.kunoGruppenAntwort = neueWarengruppenAntwort;

  var RE_ABEND = /(abends|abend|feierabend|fernseher)/;
  var RE_SALZ = /(^|[^a-zäöüß])(salz|salzarm|salzbewusst|ungesalzen|natriumarm)/;
  var RE_GETRAENK = /(getränk|getraenk|ungesüßt|ungesuesst|kaltaufg|trinken|trinkt)/;

  if (typeof classifyVoll === 'function') {
    var altVoll = classifyVoll;
    classifyVoll = function (text) {
      var s = String(text == null ? '' : text).toLowerCase().trim();
      var r = altVoll(text);
      if (!r) return r;

      /* Sperrliste, Named Disease und Umlenkung gewinnen immer. */
      if (r.redirect) return r;
      var gesperrt = (typeof results !== 'undefined') &&
        (r === results.blocked || r === results.krankheit ||
         r === results.longevity || r === results.gesund);
      if (gesperrt) return r;

      /* results.generic ist die Rueckfrage "Was ist dir wichtiger" und
         traegt noProduct. Sie darf nicht vor vegan/vegetarisch
         herausspringen - genau daran sind beide in der ersten
         Vorschau haengen geblieben. Jede andere noProduct-Antwort
         (Versand, Verbrauch, Rueckfrage) bleibt unangetastet. */
      var istGeneric = (typeof results !== 'undefined') && r === results.generic;
      if (r.noProduct && !istGeneric) return r;

      var vg = veganAntwort(s); if (vg) return vg;
      var vt = vegetarischAntwort(s); if (vt) return vt;
      if (r.noProduct) return r;

      var ausResults = false, k;
      if (typeof results !== 'undefined') {
        for (k in results) if (results[k] === r) { ausResults = true; break; }
      }
      /* Der Sammelzweig fuer snack/salz/nuss/pistaz/mandel und das
         blosse Wort "tee" fallen weg - beides laeuft jetzt ueber die
         Warengruppen. */
      var snackWeg = (typeof results !== 'undefined' && r === results.snack) && !RE_ABEND.test(s);
      var teeWeg   = (typeof results !== 'undefined' && r === results.tea)   && !RE_GETRAENK.test(s);

      if (r.eyebrow === 'Warengruppe' || snackWeg || teeWeg || (ausResults && istEingegrenzt(s))) {
        var neu = neueWarengruppenAntwort(s);
        if (neu) return neu;
      }
      if (snackWeg && RE_SALZ.test(s)) { var sa = salzAntwort(); if (sa) return sa; }
      if (snackWeg || teeWeg) return (typeof results !== 'undefined' && results.generic) ? results.generic : r;
      return r;
    };
  }
})();
